<template>
  <WidgetCard title="Inaktiva e-böcker" subtitle="Att granska">
    <v-data-table
      hide-default-footer
      :headers="[
        {text: 'Avser', value: 'person', width: '150', sortable: false},
        {text: 'Avtalstillhörighet', value: 'contracttype', width: '129', sortable: false},
        {text: 'Företag', value: 'company', width: '180', sortable: false},
        {text: 'Yrke', value: 'profession', width: '120', sortable: false},
        {text: 'Region', value: 'region', width: '180', sortable: false},
        {text: 'Inaktiverad', value: 'endDate', sortable: false, width: '100'},
        {text: '', value: 'notes', sortable: false, width: '50'}
      ]"
      :items="books"
      :server-items-length="totalRowCount"
      item-key="id"
      class="clickable"
      @click:row="onRowClick($event)"
    >
      <template slot="item.person" slot-scope="props">
        {{ formatFullName(get(props, 'item.person', null)) }}
        <template v-if="get(props, 'item.person.personalNumber')">
          ({{ get(props, 'item.person.personalNumber', null) | formatSecretPnr }})
        </template>
      </template>

      <template slot="item.contracttype" slot-scope="props">
        {{ get(props, 'item.apprenticeship.company.contracttype.name', '') }}
      </template>

      <template slot="item.company" slot-scope="props">
        {{ get(props, 'item.apprenticeship.company.name', '') }}
      </template>

      <template slot="item.profession" slot-scope="props">
        {{ get(props, 'item.profession.name', '') }}
      </template>

      <template slot="item.region" slot-scope="props">
        {{ get(props, 'item.region.name', '') }}
      </template>

      <template slot="item.endDate" slot-scope="props">
        <span class="widget-normal">{{ get(props, 'item.education.endDate', null) | date }}</span>
      </template>
    </v-data-table>
  </WidgetCard>
</template>

<script>
import API from '@/services/api'
import WidgetCard from '@/components/widgets/WidgetCard.vue'
import get from 'lodash/get';
import {mapGetters} from 'vuex'

export default {
  name: 'InactiveBooks',

  components: { WidgetCard },

  props: {
    companyId: {
      type: Number,
      default: null
    }
  },

  data: () => ({
    response: null
  }),
  
  created() {
    this.fetchBooks()
  },

  watch: {
    handledCasesAreVisible: {
      handler() {
        this.fetchBooks()
      }
    }
  },

  computed: {
    ...mapGetters('currentuser', ['handledCasesAreVisible']),

    books() {
      return get(this, 'response.data.rows', [])
    },

    totalRowCount() {
      return get(this, 'response.data.count', 0)
    }
  },

  methods: {
    get,

    onRowClick(row) {
      this.$router.push({
        name: 'PersonDetail', 
        params: { id: get(row, 'personId', -1) }, 
        query: { tab: 4 } 
      })
    },

    async fetchBooks() {
      try {
        let params = { data: { toggleMyHandledCases: this.handledCasesAreVisible } }
        if ( this.companyId ) params.data = { ...params.data, companyId: this.companyId }
        this.response = await API.listInactiveBooks(params)
      } catch (error) {
        console.log(`Error | fetch inactive books | ==> ${error}`);
        this.$events.fire('showError', 'Ett fel uppstod vid hämtning av inaktiva e-böcker')
      }
    },

    formatFullName(person) {
      return `${get(person, 'firstName', '')} ${get(person, 'lastName', '')}`
    }
  }
}
</script>

<style scoped>
</style>
